/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Cookies_TitleInputs */

const en_legal_cookies_title = /** @type {(inputs: Legal_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Policy`)
};

const pl_legal_cookies_title = /** @type {(inputs: Legal_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka cookies`)
};

/**
* | output |
* | --- |
* | "Cookie Policy" |
*
* @param {Legal_Cookies_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_cookies_title = /** @type {((inputs?: Legal_Cookies_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Cookies_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_cookies_title(inputs)
	return en_legal_cookies_title(inputs)
});